import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import { loadStorage, saveStorage } from '../../services/storage'

// That's our local storage key
const STORAGE_KEY = '@adopets/admin-theme'

interface ThemeContextState extends BaseContextState {
  sideMenuCollapsed: boolean
}

export interface ThemeContextData extends ThemeContextState {
  setSideMenuCollapse: (collapsed: boolean) => void
}

// Create context
export const ThemeContext = createContext({} as ThemeContextData)
const { Provider, Consumer } = ThemeContext

// Export consumer
export const ThemeConsumer = Consumer

export class ThemeProvider extends BaseContextProvider {
  state: ThemeContextState = {
    sideMenuCollapsed: false
  }

  constructor(props: any) {
    super(props)

    const store = loadStorage(STORAGE_KEY)

    // We do have stored user data?
    if (store) {
      this.state = {
        ...this.state,
        ...store
      }
    }
  }

  /**
   * Change menu collapsed state
   * 
   * @param {boolean} collapsed
   */
  setSideMenuCollapse = (collapsed: boolean) => {
    this.setState({
      sideMenuCollapsed: collapsed
    }, () => {
      saveStorage(STORAGE_KEY, this.state)
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          setSideMenuCollapse: this.setSideMenuCollapse
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
